import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import ContactHub from './ContactHub';

const FooterStyles = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  background: var(--footerBackground);
  align-items: center;
  align-content: center;
  gap: 1rem;

  margin-top: 6rem;
  padding: 2rem;

  @media (max-width: 800px) {
    margin-top: 2rem;
  }

  hr {
    display: block;
    max-width: 100%;
    height: 0;
    max-height: 0;
    border: solid;
    width: 100%;
    border-width: thin 0 0 0;
    transition: inherit;
    border-color: var(--lightShade);
    color: var(--lightShade);
  }

  p {
    margin: 0;
    padding: 0.2rem;
    font-weight: 600;
    color: var(--lightShade);
  }

  ul {
    margin: 0.5rem;
  }
`;

const FooterPageListStyles = styled.nav`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 1rem;

  a {
    margin: 1rem;
    line-height: 1rem;
  }
`;

export default function Footer() {
  const userNames = {
    github: 'BradNut',
    linkedIn: 'bradley-shellnut',
    email: 'bradleyshellnut@pm.me',
  };

  return (
    <footer>
      <FooterStyles>
        <div style={{ paddingBottom: '2rem' }}>
          <ContactHub
            github
            linkedIn
            email
            userNames={userNames}
            theme="dark"
          />
        </div>
        <FooterPageListStyles aria-label="footer navigation">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/uses">Uses</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/articles">Favorite Articles</Link>
        </FooterPageListStyles>
        <p className="center">
          Bradley Shellnut &copy; 2012 - {new Date().getFullYear()}
        </p>
      </FooterStyles>
    </footer>
  );
}
